import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    ADD_TABLE,
    ADD_TABLE_SUCCESS,
    ADD_TABLE_ERROR
}
    from "../../actions/table";

function* addTableSaga(action) {
    try {
        const data =  yield call(tableService.AddTable, action.payload)
        yield put({
            type: ADD_TABLE_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_TABLE_ERROR,error: error.data
        });
    }
}


export function* addTableSagaWatcher() {
    yield takeLatest(ADD_TABLE, addTableSaga);
}